
(function() {
  var result = { translations: { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.1033"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1033",
    "ar-eg": "static-7.1033",
    "bg": "static-7.1033",
    "bn": "static-7.1033",
    "ca-es": "static-7.1033",
    "cs": "static-7.1033",
    "da": "static-7.1033",
    "de": "static-7.1033",
    "el": "static-7.1033",
    "en-gb": "static-7.1033",
    "en": "static-7.1033",
    "es-mx": "static-7.1033",
    "es": "static-7.1033",
    "et": "static-7.1033",
    "fi": "static-7.1033",
    "fr-ca": "static-7.1033",
    "fr": "static-7.1033",
    "he-il": "static-7.1033",
    "hi": "static-7.1033",
    "hr": "static-7.1033",
    "hu": "static-7.1033",
    "id": "static-7.1033",
    "it": "static-7.1033",
    "ja": "static-7.1033",
    "ko": "static-7.1033",
    "lt": "static-7.1033",
    "ms": "static-7.1033",
    "nl": "static-7.1033",
    "no": "static-7.1033",
    "pl": "static-7.1033",
    "pt-br": "static-7.1033",
    "pt-pt": "static-7.1033",
    "ro": "static-7.1033",
    "ru": "static-7.1033",
    "sk": "static-7.1033",
    "sl": "static-7.1033",
    "sv": "static-7.1033",
    "th": "static-7.1033",
    "tl": "static-7.1033",
    "tr": "static-7.1033",
    "uk": "static-7.1033",
    "vi": "static-7.1033",
    "x-pseudo": "static-7.1033",
    "zh-cn": "static-7.1033",
    "zh-hk": "static-7.1033",
    "zh-tw": "static-7.1033"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.1033'}); }
})();


